/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-08 14:41:12
 */

async function getCommodityStock (handle) {
  return new Promise((resolve, reject) => {
    window
      .yhsd
      .ready(function (sdk) {
        return sdk
          .product
          .get(handle, function (inf) {
            //  如果取不到商品，则商品下架或不存在
            if (!inf.res.product) {
              resolve(0)
              return
            }
            let stock = 0
            for (let variant of inf.res.product.variants) {
              stock += variant.stock
            }
            resolve(stock)
          })
      })
  })
}

export {getCommodityStock}



// WEBPACK FOOTER //
// ./src/api/getCommodityStock.js